import withIsVisibleHOC from "@client/hocs/withIsVisible";
import HeaderElement from "@client/widgets/Header/Element/container";
import classnames from "classnames";
import React from "react";

export interface SearchToggleMapProps {
  isToggled: boolean;
}

export interface SearchToggleActionProps {
  onToggle: () => void;
}

export type SearchToggleProps = SearchToggleActionProps & SearchToggleMapProps;

const HeaderSearchToggle = (props: SearchToggleProps) => (
  <HeaderElement className="top-search-trigger">
    <i
      onClick={props.onToggle}
      className={classnames({ "far fa-search": !props.isToggled, "far fa-close": props.isToggled })}
    />
  </HeaderElement>
);
export default withIsVisibleHOC(HeaderSearchToggle);
